import React from 'react'

const ImageInCoverStyle = ({imageUrl, width, height}) => (
  <div style={{
    width: width,
    height: height,
    backgroundImage: `url(${imageUrl})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat'}}>
  </div>
)

export default (ImageInCoverStyle)
